import _ from 'lodash'
import { createContext, useContext, useEffect, useReducer, useState } from 'react'
import { golfRoundHandlers, golfRoundInitialState, golfRoundReducer } from '../reducers/GolfRoundReducer'
import { GolfParentContext } from './GolfParentContext'

export const GolfRoundContext = createContext();

export const GolfRoundProvider = (props) => {


  const { roundKey, roundKeyDirect, displaySize } = props
  const _roundKey = roundKeyDirect ? roundKeyDirect : roundKey

  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states } = golfParent_contexts ?? {}
  const { golfTournament_state } = states ?? {}

  const {
    matches_rounds,
    roundsStatus,
    autoScoringOn,
    autoScoringRoundKey,
  } = golfTournament_state ?? {}

  const init_state = { roundKey: _roundKey, initDisplaySize: displaySize }
  const [golfRound_state, golfRound_dispatch] = useReducer(golfRoundReducer, init_state, golfRoundInitialState)
  const golfRound_handlers = golfRoundHandlers(golfRound_dispatch, golfRound_state)
  const { roundStatus, roundMatches } = golfRound_state
  const { matchStatuses } = roundStatus ?? {}
  const { handleAmmend_golfRound } = golfRound_handlers

  const [currentRoundMatches, setCurrentRoundMatches] = useState()

  useEffect(() => {
    if (_roundKey) {
      if (matches_rounds && roundsStatus) {
        const _roundStatus = roundsStatus[_roundKey]
        const _roundMatches = matches_rounds[_roundKey]
        handleAmmend_golfRound(_roundKey, _roundStatus, _roundMatches)
      } else {
        handleAmmend_golfRound(_roundKey, {}, {})
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches_rounds, roundsStatus, _roundKey]);

  useEffect(() => {
    if (roundStatus && roundMatches) {

      const availableMatches = {};

      // get the available matches for the round
      _.forEach(roundMatches, (match_round, match_round_key) => {
        let matchStatus = matchStatuses?.[match_round_key] ?? null;
        if (!matchStatus?.finished) {
          // if the match is NOT finished, add it to availableMatches 
          availableMatches[match_round_key] = match_round;
        }
      });

      // if (_.isEmpty(availableMatches)) {
      //   setRunRandomMatches(false);
      // } else {
      //   setRunRandomMatches(true);
      // }

      // only reset index if the actual list of available matches changes (not just their contents)
      const oldKeys = Object.keys(currentRoundMatches ?? {});
      const newKeys = Object.keys(availableMatches);

      const keysChanged =
        oldKeys.length !== newKeys.length ||
        !_.isEqual(_.sortBy(oldKeys), _.sortBy(newKeys));

      // if (keysChanged) {
      //   setMatchIndex(0);
      // }

      setCurrentRoundMatches(availableMatches);
    }
  }, [roundMatches]);

  return (
    <GolfRoundContext.Provider value={{ golfRound_handlers, golfRound_state }} >
      {props.children}
    </GolfRoundContext.Provider>
  )
}
